export function getTranslationObject(row, lang) {
	// Make sure the translations property exists.
	if (!row.translations) {
		row.translations = {};
	}

	// If the language translation exists already, use it.
	if (row.translations[lang]) return row.translations[lang];

	// If not, create it based on whether this row is a "group"
	// (if groupKeys is an array with items) or a single item.
	const isGroup = Array.isArray(row.groupKeys) && row.groupKeys.length > 0;

	if (isGroup) {
		// Create group type translation using fieldLimits if available
		row.translations[lang] = {
			group: row.groupKeys.map((key) => ({
				key,
				value: "",
				// Use fieldLimits if available, otherwise leave maxLength undefined
				...(row.fieldLimits &&
					row.fieldLimits[key] !== undefined && {
						maxLength: row.fieldLimits[key],
					}),
			})),
		};
	} else {
		// Create single item translation using fieldLimits if available
		const descMaxLength = row.fieldLimits?.description;
		row.translations[lang] = {
			item: {
				key: "description",
				value: "",
				...(descMaxLength !== undefined && { maxLength: descMaxLength }),
			},
		};
	}
	return row.translations[lang];
}

export function computeLanguageCompletion(languages, tableData) {
	const total = tableData.length || 1;
	return languages.map((lang) => {
		if (lang.code === "BASE") return lang; // Skip base text

		let complete = 0;

		tableData.forEach((row) => {
			const translation = getTranslationObject(row, lang.code);
			if (translation.item) {
				if (translation.item.value.trim().length > 0) {
					complete++;
				}
			} else if (translation.group) {
				if (
					translation.group.every(
						(item) => item.value && item.value.trim().length > 0
					)
				) {
					complete++;
				}
			}
		});

		const percentage = Math.round((complete / total) * 100);
		return { ...lang, percentage };
	});
}

export function isEmptyTranslation(translation) {
	if (!translation) {
		return true;
	}

	if (translation?.item) {
		return translation.item?.value?.trim().length === 0;
	} else if (translation.group) {
		return translation.group?.every((item) => item.value?.trim().length === 0);
	}

	return true;
}

export function sortTableData(tableData, selectedLang) {
	return tableData.slice().sort((a, b) => {
		const aTranslation = getTranslationObject(a, selectedLang);
		const bTranslation = getTranslationObject(b, selectedLang);

		const aIsEmpty = isEmptyTranslation(aTranslation);
		const bIsEmpty = isEmptyTranslation(bTranslation);

		if (aIsEmpty && !bIsEmpty) {
			return -1;
		}

		if (!aIsEmpty && bIsEmpty) {
			return 1;
		}

		return 0;
	});
}
